import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { find } from 'lodash';

const initialState = {
  plans: [],
  currentPage: 1,
  totalPages: 1,
  totalCount: 0,
  loading: false,
  isPlanCreated: false,
  isPlanEdited: false,
  selectedPlan: {},
  error: null,
};

const planSlice = createSlice({
  name: 'plans',
  initialState,
  reducers: {
    fetchPlansRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchPlansSuccess(state, action) {
      state.loading = false;
      state.plans = action.payload.plans;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalCount = action.payload.totalCount;
    },
    fetchPlansFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    fetchPlanById(state) {
      state.loading = true;
      state.error = null;
    },
    fetchPlanByIdSuccess(state, action) {
      const plan = action.payload;
      let found = find(state.plans, { _id: plan._id });
      if (!found) {
        state.plans.push(plan);
      }
      state.loading = false;
      state.selectedPlan = action.payload;
    },
    fetchPlanByIdFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    createPlanRequest(state) {
      state.loading = true;
      state.error = null;
      state.isPlanCreated = false;
    },
    editPlanRequest(state) {
      state.loading = true;
      state.error = null;
      state.isPlanEdited = false;
    },
    createPlanSuccess(state) {
      state.loading = false;
      state.error = null;
      state.isPlanCreated = true;
    },
    editPlanFailure(state, action) {
      state.loading = false;
      state.isPlanEdited = false;
      state.error = action.payload;
    },
    editPlanSuccess(state) {
      state.loading = false;
      state.error = null;
      state.isPlanEdited = true;
    },
    createPlanFailure(state, action) {
      state.loading = false;
      state.isPlanCreated = false;
      state.error = action.payload;
    },
    cancelPlanCreate(state) {
      state.loading = false;
      state.error = null;
      state.isPlanCreated = false;
      state.isPlanEdited = false;
    },
    markPlanCreated(state, action) {
      state.isPlanCreated = action.payload;
    },
    markPlanEdited(state, action) {
      state.isPlanEdited = action.payload;
    },
  },
});

export const {
  fetchPlansRequest,
  fetchPlansSuccess,
  fetchPlansFailure,
  fetchPlanById,
  fetchPlanByIdSuccess,
  fetchPlanByIdFailure,
  createPlanRequest,
  createPlanSuccess,
  createPlanFailure,
  editPlanRequest,
  editPlanFailure,
  editPlanSuccess,
  markPlanCreated,
  markPlanEdited,
  cancelPlanCreate,
} = planSlice.actions;

const planState = (state) => state.plans;

export const selectPlanById = (id) =>
  createSelector([planState], (planState) => planState.plans.find((plan) => plan._id === id) || {});

export default planSlice.reducer;
